module.exports = __webpack_public_path__ + "static/backdrop-bottom-dc3c4f302f9295dfb5cddadf51d01ab4.jpg";